/**
 * @fileoverview GET handler for the "/engagement/canvases_for_uco" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appGroupIdCanvasesForUco } from "./constants";
import type { CanvasesForUcoResult } from "./types";
import { isCanvasesForUcoResult } from "./validators";

export const getCanvasesForUco = reactQueryFetcherAdapter(
  appGroupIdCanvasesForUco,
  (signal: AbortSignal): Promise<CanvasesForUcoResult> => {
    return fetch(`/engagement/canvases_for_uco`, "GET", {}, { signal });
  },
  isCanvasesForUcoResult
);
